import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

/**
 * TrustStrip
 *
 * Full-width dark strip directly under the store header.
 * Three equal cells. International (USD region) has no COD and no fixed return
 * window, so it swaps to refund-if-damaged · ships-worldwide · secure pay.
 */
export default function TrustStrip() {
  const { t } = useTranslation();
  const isIntl = useSelector((s) => s.location?.currency) === "USD";
  // Key names, not copy -- resolved at render so a language switch re-reads them.
  const items = isIntl
    ? [
        { e: "trustStrip.refund", t: "trustStrip.ifDamaged" },
        { e: "trustStrip.ships", t: "trustStrip.worldwide" },
        { e: "trustStrip.hundredPercent", t: "trustStrip.securePay" },
      ]
    : [
        { e: "trustStrip.sevenDay", t: "trustStrip.easyReturns" },
        { e: "trustStrip.cod", t: "trustStrip.available" },
        { e: "trustStrip.hundredPercent", t: "trustStrip.securePay" },
      ];

  return (
    <div className="flex bg-ink-900 text-white">
      {items.map((it, i) => (
        <div
          key={it.e}
          className={`flex-1 px-[5px] py-[8px] text-center leading-[1.2] text-[9.5px] ${
            i < items.length - 1 ? "border-r border-white/10" : ""
          }`}
        >
          <span className="block font-[500] text-[10px] text-[#FFE08A]">
            {t(it.e)}
          </span>
          {t(it.t)}
        </div>
      ))}
    </div>
  );
}
